<template>
	<div class="widget">
		<!-- widget-body -->
		<div class="widget-body">
			<Form :model="widgetData">
				<FormItem label="Title">
					<Input v-model="widgetData.title" />
				</FormItem>

				<FormItem label="Type">
					<Select v-model="widgetData.type" placeholder="Please select one">
		        <Option v-for="t in types" :value="t" :key="t">
		          {{t}}
		        </Option>
		      </Select>
				</FormItem>

				<template v-if="widgetData.type === 'Iframe'">
					<FormItem label="Iframe Url">
						<Input v-model="widgetData.iframeUrl" />
					</FormItem>
				</template>

				<template v-else-if="widgetData.type === 'HTML'">
					<vue-editor
						v-model="widgetData.html" />
				</template>

        <template v-else-if="widgetData.type === 'Speakers'">
					<Speakers/>
				</template>
        <template v-else-if="widgetData.type === 'Downloads'">
					<Downloads/>
				</template>        

			</Form>
		</div>
	</div>
</template>

<script>
	import {
  	mapState,
  	mapGetters,
  	mapActions
	} from 'vuex'

	import { VueEditor } from 'vue2-editor'
  import Speakers from '@/components/widgets/Speakers.vue'
  import Downloads from '@/components/widgets/Downloads.vue'

	export default {
		props: ['widgetData', 'types'],

		data () {
    	return {
    	  wc: undefined,
    	}
  	},

  	methods: {
  		setWidgetCopy () {
  			this.$set(this.$data, 'wc', this.$store.state.webcast.copy)
  		}
  	},

  	components: {
  		VueEditor,
      Speakers,
      Downloads

  	},

		created () {
    	this.setWidgetCopy()
  	}
	}
</script>
